import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import NumberFormat from 'react-number-format'

/*
 * This component as it is now only works in Redux Form forms
 */
class Input extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.input.value
    }
    this.inputRef = React.createRef()
  }
  componentDidMount () {
    if (this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  render () {
    const {
      id,
      input: {
        value: inputValue,
        onChange,
        ...restInput
      },
      placeholder,
      type,
      meta: { touched, error },
      block,
      disabled,
      numberFormat,
      prefix
    } = this.props
    const {
      value
    } = this.state
    return (
      <NumberFormat
        id={id}
        fullWidth={block}
        value={value}
        format={numberFormat}
        mask='_'
        customInput={TextField}
        inputRef={this.inputRef}
        onChange={this.handleChange}
        helperText={touched && error}
        error={touched && !!error}
        label={placeholder}
        type={type}
        margin='normal'
        disabled={disabled}
        prefix={prefix}
        FormHelperTextProps={{
          'data-testid': `test-${id}-helper-text`
        }}
        {...restInput}
      />
    )
  }

  /*
   * This function handles a problem detailed here: https://github.com/facebook/react/issues/12762
   */
  handleChange = e => {
    const {
      normalizers,
      input: {
        onChange
      }
    } = this.props
    const {
      selectionStart,
      selectionEnd
    } = this.inputRef.current
    const newValue = normalizers
      ? normalizers.reduceRight((val, fn) => fn(val), e.target.value)
      : e.target.value
    this.setState({
      value: newValue
    }, () => {
      this.inputRef.current.setSelectionRange(selectionStart, selectionEnd)
      onChange(newValue)
    })
  }
}

Input.propTypes = {
  input: PropTypes.object,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  block: PropTypes.bool,
  id: PropTypes.string,
  normalizers: PropTypes.array,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  numberFormat: PropTypes.string,
  prefix: PropTypes.string
}

Input.defaultValues = {
  block: false
}

export default Input
